export default {
    title_list: 'Gift Memberships',
    title_page: 'Gift Membership',
    title_create_page: 'Create gift Membership',
    title_edit_page: 'Change gift Membership',

    filter: {
        labels: {
            plan_id: 'Tariff plan',
            parent_id: 'Parent',
            user_id: 'User',
        }
    },

    table: {
        labels: {
            id: 'ID',
            plan_id: 'Tariff plan',
            parent_id: 'Parent',
            user_id: 'User',
            occasion_id: 'Occasion',
        }
    },

    buttons: {

    },

    form: {
        plan_id: 'Tariff plan',
        parent_id: 'Parent',
        code: 'Promo code',
        user_id: 'User',
        email: 'Email',
        from_name: 'Sender name',
        to_name: 'Receiver name',
        send_at: 'departure date',
        occasion_id: 'Occasion',
        message: 'Message',
        sender_notify: 'Notify sender',
    },
}
